"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTssStyles = exports.useEmptyStyles = exports.tss = exports.makeTssStyles = void 0;
var _tssReact = require("tss-react");
var _useTheme = require("./useTheme");
function useContext() {
  const theme = (0, _useTheme.useTheme)();
  return {
    theme
  };
}
const {
  tss
} = (0, _tssReact.createTss)({
  useContext
});
exports.tss = tss;
const useEmptyStyles = exports.useEmptyStyles = tss.create({});
const {
  makeStyles: makeTssStyles,
  withStyles: withTssStyles
} = (0, _tssReact.createMakeAndWithStyles)({
  useTheme: _useTheme.useTheme
});
exports.withTssStyles = withTssStyles;
exports.makeTssStyles = makeTssStyles;